
import { defineComponent } from 'vue'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'ExplainDateRange',
  components: {
    EpbText,
  },
  props: {
    dateRangeText: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      baseClass: 'epb-explain-date-range',
    }
  },
})
